<template>
  <div :class="['t-toolbar', toolbarClass]"><slot></slot></div>
</template>

<script>
export default {
  name: 'Toolbar',

  props: {
    direction: {
      type: String,
      required: true,
      validator: v => ['horizontal', 'vertical'].includes(v),
    },
  },

  computed: {
    toolbarClass() {
      return `t-${this.direction}`
    },
  },
}
</script>
